import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Tabs,
    Tab,
    Divider
} from '@material-ui/core';

import {
    Translate
} from "src/shared_modules/i18n";

import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";
import ScrollContainer from "src/shared_modules/veu-visitors-core/components/common/container/scrollContainer";

import TabContent from "src/shared_modules/veu-visitors-core/components/common/tabbar/tabcontent";

import PopoverLogin from "./login";
import PopoverRegister from "./register";
import PopoverRegisterSuccess from "./register-success";
import PopoverProfile from "./profile";
import PopoverPrivacy from "./privacy";
import PopoverAccount from "./account";
import PopoverForgot from "./forgot";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import './user.css';

class UserPopoverProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            forceScrollUpdate : false
        }
        this.handleTabChanged = this.handleTabChanged.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {
        if( prevState.forceScrollUpdate === true && this.state.forceScrollUpdate === true ) {
            this.setState({ forceScrollUpdate : false });
        }
    }

    handleTabChanged(event, newValue){

        if( newValue === 0 )
            this.props.showPopover("Profile",{ openInUserTabContainer : true });
        else if( newValue === 1 && this.props.hasPlazzConvention )
            this.props.showPopover("Privacy",{ openInUserTabContainer : true });
        else
            this.props.showPopover("Account",{ openInUserTabContainer : true });

        this.setState({ forceScrollUpdate : true });

    }


    handleClose() {
        if( this.props.showProfile )
            this.props.hidePopover("Profile",{ openInUserTabContainer : false });

        if( this.props.showPrivacy )
            this.props.hidePopover("Privacy",{ openInUserTabContainer : false });

        if( this.props.showAccount )
            this.props.hidePopover("Account",{ openInUserTabContainer : false });
    }

    renderSingleContainer() {
        if( this.props.showPrivacy === false
                && this.props.showAccount === false
                && this.props.showProfile === false )
            return(null);

        return(<FloatingContainer modal
                        position="center"
                        width="sm"
                        fsSwitch="xs"
                        className="user"
                        largeBottomPadding={this.props.event.hasUserlike}
                    >
                    <ScrollContainer>
                        { this.props.showPrivacy && <PopoverPrivacy /> }
                        { this.props.showAccount && <PopoverAccount /> }
                    </ScrollContainer>
            </FloatingContainer>);

    }

    renderTabContainer() {
        if( this.props.showPrivacy === false
                && this.props.showAccount === false
                && this.props.showProfile === false )
            return(null);

        let activeIndex = 0;

        // toggle active visible content component
        if( this.props.showProfile )
            activeIndex = 0;
        else if( this.props.showPrivacy )
            activeIndex = 1;
        else if( this.props.showAccount && this.props.hasPlazzConvention )
            activeIndex = 2;
        else
            activeIndex = 1;

        return(<FloatingContainer position="center"
                        width="md"
                        fsSwitch="md"
                        className="user fixed-height"
                        onCloseButton={ ()=> this.handleClose() }
                        largeBottomPadding={this.props.event.hasUserlike}
                    >
                    <Tabs value={ activeIndex }
                            onChange={this.handleTabChanged}
                            variant="fullWidth"
                            aria-label="tabs visitors and conversations"
                            indicatorColor="secondary"
                            textColor="secondary"
                        >
                        <Tab label={ <Translate>popovers.user-tabs.profile</Translate> }  id="full-width-tab-0" />
                        { this.props.hasPlazzConvention && <Tab label={ <Translate>popovers.user-tabs.privacy</Translate> } id="full-width-tab-1" /> }
                        <Tab label={ <Translate>popovers.user-tabs.account</Translate> } id="full-width-tab-2" />
                    </Tabs>
                    <Divider />
                    <TabContent className="outer-flex-scroll-container profile-tabs">
                        <ScrollContainer forceScrollUpdate={this.state.forceScrollUpdate} >
                            { this.props.showProfile && <PopoverProfile /> }
                            { this.props.showPrivacy && <PopoverPrivacy /> }
                            { this.props.showAccount && <PopoverAccount /> }
                        </ScrollContainer>
                    </TabContent>
            </FloatingContainer>);
    }

    render() {
        return (<React.Fragment>
                    {/*  always single popovers */}
                    <PopoverLogin />
                    <PopoverForgot />
                    <PopoverRegister />
                    <PopoverRegisterSuccess />
                    { /* TODO <PopoverForgot /> */ }
                    { this.props.openInUserTabContainer === false && this.renderSingleContainer() }
                    { this.props.openInUserTabContainer === true && this.renderTabContainer() }
            </React.Fragment>);
    }
}

UserPopoverProvider.propTypes = {
    openInUserTabContainer: PropTypes.bool,
    showProfile: PropTypes.bool,
    showPrivacy: PropTypes.bool,
    showAccount: PropTypes.bool,
    hasPlazzConvention: PropTypes.bool,
    event: PropTypes.object,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        openInUserTabContainer : state.popovers.openInUserTabContainer,
        showProfile : state.popovers.showProfile,
        showPrivacy : state.popovers.showPrivacy,
        showAccount : state.popovers.showAccount,
        hasPlazzConvention : state.event.hasPlazzConvention,
        event: state.event,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(UserPopoverProvider);
